import React from 'react';

const FieldMessage = ({ field, ErrorIcon }) => {
  return (
    <div className="mvp-mail-subscription__message">
      {/* <ErrorIcon className="icon-error" /> */}
      <p>{field.validationMessage}</p>
    </div>
  );
};

export default FieldMessage;
